import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface InstallmentItem {
  _id: string;
  code: string;
  order: number;
  amount: number;
  dueBalance: number;
  scheduledPaymentDate: string;
  paymentDate: string | null;
  status: 'PAID' | 'OVERDUE' | 'PENDING';
  paymentStatusName: string;
  daysOverdue: number;
  penalties: number;
  totalFees: number;
  feeCount: number;
  invoice: {
    identifier: string;
    code: string;
    currency: string;
    rate: number;
    productType: string;
    shopName: string;
  };
}

export interface InstallmentsPlanSummary {
  total: number;
  paid: number;
  overdue: number;
  pending: number;
  totalDebt: number;
  totalPenalties: number;
}

export interface WidgetInstallmentsPlanResponse {
  success: boolean;
  data: {
    person: any;
    summary: InstallmentsPlanSummary;
    installments: InstallmentItem[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class WidgetInstallmentsPlanService {
  private baseUrl = environment.BASE_LA;

  constructor(private http: HttpClient) {}

  getInstallmentsPlan(personId: string, token: string, products?: string): Promise<WidgetInstallmentsPlanResponse> {
    let params = new HttpParams().set('token', token);
    if (products) params = params.set('products', products);
    const headers = { 'X-Skip-Auth-Interceptor': 'true' };

    return lastValueFrom(
      this.http.get<WidgetInstallmentsPlanResponse>(
        `${this.baseUrl}/api/widget/installments-plan/person/${personId}`,
        { params, headers }
      )
    );
  }
}
